import { SpoSportsResponse } from '@spo/types';
import { SelectOptions } from './types';

export const getDataSports = async (
  searchedSportsData: SpoSportsResponse | undefined,
): Promise<SelectOptions[]> => {
  let sports: SelectOptions[] = [];
  if (searchedSportsData?.length) {
    sports = searchedSportsData?.map((sport) => ({
      label: `${sport.id} - ${sport.name}`,
      value: sport.id,
      name: `${sport.name}`,
    }));
  }
  return sports;
};
